@charset "utf-8";
.qmsg.qmsg-wrapper {
  position: fixed;
  top: 16px;
  left: 0;
  z-index: 50000;
  display: flex;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  width: 100%;
  color: rgba(0, 0, 0, 0.55);
  list-style: none;
  font-variant: tabular-nums;
  font-size: 13px;
  line-height: 1;
  font-feature-settings: "tnum";
  pointer-events: none;
  flex-direction: column;
}
.qmsg.qmsg-data-position-center,
.qmsg.qmsg-data-position-left,
.qmsg.qmsg-data-position-right {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.qmsg.qmsg-data-position-bottom,
.qmsg.qmsg-data-position-bottomleft,
.qmsg.qmsg-data-position-bottomright {
  position: fixed;
  top: unset;
  bottom: 0;
  bottom: 8px;
  left: 50%;
  transform: translate(-50%, 0);
}
.qmsg.qmsg-data-position-bottomleft .qmsg-item,
.qmsg.qmsg-data-position-left .qmsg-item,
.qmsg.qmsg-data-position-topleft .qmsg-item {
  text-align: left;
}
.qmsg.qmsg-data-position-bottom .qmsg-item,
.qmsg.qmsg-data-position-center .qmsg-item,
.qmsg.qmsg-data-position-top .qmsg-item {
  text-align: center;
}
.qmsg.qmsg-data-position-bottomright .qmsg-item,
.qmsg.qmsg-data-position-right .qmsg-item,
.qmsg.qmsg-data-position-topright .qmsg-item {
  text-align: right;
}
.qmsg .qmsg-item {
  position: relative;
  padding: 8px;
  text-align: center;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
}
.qmsg .qmsg-item .qmsg-count {
  position: absolute;
  top: -4px;
  left: -4px;
  display: inline-block;
  height: 16px;
  min-width: 16px;
  border-radius: 2px;
  background-color: red;
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
}
.qmsg .qmsg-item:first-child {
  margin-top: -8px;
}
.qmsg .qmsg-content {
  position: relative;
  display: inline-block;
  padding: 10px 12px;
  max-width: 80%;
  min-width: 40px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  text-align: center;
  pointer-events: all;
}
.qmsg .qmsg-content [class^="qmsg-content-"] {
  display: flex;
  align-items: center;
}
.qmsg .qmsg-icon {
  position: relative;
  top: 1px;
  display: inline-block;
  margin-right: 8px;
  color: inherit;
  vertical-align: -0.125em;
  text-align: center;
  text-transform: none;
  font-style: normal;
  font-size: 16px;
  line-height: 0;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.qmsg .qmsg-icon svg {
  display: inline-block;
}
.qmsg .qmsg-content .qmsg-show-more-content {
  display: flex;
  align-items: center;
  white-space: unset;
  overflow: unset;
  text-overflow: unset;
  padding-right: unset;
}
.qmsg .qmsg-content-info .qmsg-icon {
  color: #1890ff;
}
.qmsg .qmsg-icon-close {
  margin: 0;
  margin-left: 8px;
  padding: 0;
  outline: 0;
  border: none;
  background-color: transparent;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  cursor: pointer;
  transition: color 0.3s;
}
.qmsg .qmsg-icon-close:hover > svg path {
  stroke: #555;
}
.qmsg .qmsg-icon-close.qmsg-show-more-content {
  position: unset;
  overflow: unset;
  padding-left: 6px;
  margin-right: 0;
}
.qmsg .animate-turn {
  animation: MessageTurn 1s linear infinite;
  -webkit-animation: MessageTurn 1s linear infinite;
}
